import React from "react";
import {
  Truck,
  RotateCcw,
  ShieldCheck,
  Headphones,
  PackageSearch,
} from "lucide-react";
import "./featureBanner.css";

const FEATURES = [
  {
    icon: Truck,
    title: "FREE DELIVERY",
    subtitle: "Over KSh 10,000",
  },
  {
    icon: PackageSearch,
    title: "TRACK ORDER",
    subtitle: "24/7",
  },
  {
    icon: ShieldCheck,
    title: "SECURE PAYMENTS",
    subtitle: "M-Pesa & Cards",
  },
  {
    icon: Headphones,
    title: "SUPPORT",
    subtitle: "24/7",
  },
];

export default function FeatureBanner() {
  return (
    <section className="fb-wrap">
      <div className="fb-grid">
        {FEATURES.map(({ icon: Icon, title, subtitle }) => (
          <div className="fb-item" key={title}>
            <Icon className="fb-icon" size={26} strokeWidth={1.5} />
            <div className="fb-text">
              <p className="fb-title">{title}</p>
              <p className="fb-subtitle">{subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
